import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.js';
import { fetcher } from '../../../scripts/utils/fetch.js';
import AddProductWithAccessoryModal from './views/product-with-accessory-modal.js';

export default class ProductAccessoriesApp {
	constructor() {
		this.container = document.querySelector('.js-accessories');

		this.selectors = {
			accessory: '[data-prodid]',
			qty: '[name="qty"]',
			add_to_cart_controls: '.add-to-cart',
			name: '.product-name',
			price: '.price',
			img: 'img',
			product: {
				name: '.product-head > h1',
				sku: '.product-sku',
				price: '.js-product-price-label',
				img: '#product-main-image'
			}
		};

		this.initAddBtns();
		this.initSlider();
	}

	initAddBtns() {
		this.add_btns = this.container.querySelectorAll('[name="add_to_cart"]');

		this.add_btns.forEach(elem => {
			elem.addEventListener('click', this.addAccessory.bind(this));
		});
	}

	initSlider() {

		let slider_opts = {
			container: '.js-accessories-list',
			axis: 'horizontal',
			items: 1,
			gutter: 0,
			edgePadding: 50,
			nav: false,
			loop: false,
			responsive: {
				992: {
					items: 2
				},
				1200: {
					items: 3,
				},
				1400: {
					items: 4
				},
				1900: {
					items: 5
				}
			}
		};

		this.slider = tns(slider_opts);

	}

	addAccessory(event) {
		const btn = event.currentTarget;
		const accessory = btn.closest(this.selectors.accessory);

		if (btn.classList.contains('is_accessory')) {
			this.addProductWithAccessory(accessory);
		} else {
			if (!btn.classList.contains('in-cart')) {

				const product_data = {
					ProductId: accessory.getAttribute('data-prodid'),
					ParentId: null,
					Qty: 1,
					DefaultOptions: btn.getAttribute('data-default-options') ? true : false
				};

				if (this.adv_source) {
					product_data.Source = 'ad';
				}

				btn.setAttribute('disabled', true);
				btn.classList.add('progress');

				fetcher( '/my/api/2/shopping-cart/active/product', {
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(product_data)
				})
					.then(response => {

						btn.classList.add('in-cart');
						btn.textContent = 'In cart';

						const product_added_event = new CustomEvent('[add-to-cart]:product-added', { detail: response });

						document.dispatchEvent(product_added_event);
					});
			}
		}
	}

	addProductWithAccessory(accessory) {

		const accessory_data = {
			ProductId: accessory.getAttribute('data-prodid'),
			Name: accessory.querySelector(this.selectors.name).textContent,
			Sku: accessory.querySelector(this.selectors.name).getAttribute('data-sku'),
			Url: accessory.querySelector(this.selectors.name).getAttribute('href'),
			Price: accessory.querySelector(this.selectors.price).getAttribute('data-price-original'),
			Image: accessory.querySelector(this.selectors.img).getAttribute('src'),
			Qty: 1 //accessory.querySelector(this.selectors.qty).value
		};

		const product_data = {
			ProductId: window.__prodid,
			Name: document.querySelector(this.selectors.product.name).textContent,
			Sku: document.querySelector(this.selectors.product.sku).getAttribute('data-sku'),
			Price: document.querySelector(this.selectors.product.price).getAttribute('data-price'),
			Image: document.querySelector(this.selectors.product.img).getAttribute('src')
		};

		this.accessory_modal_view = new AddProductWithAccessoryModal({
			accessory_data: accessory_data,
			product_data: product_data,
			el: '.app-product-with-accessory-placeholder',
			modal_selector: '.app-product-with-accessory-modal',
			navigation: {
				image: window.ProductInfo.Image,
				caption: window.ProductInfo.Name
			}
		});

		this.accessory_modal_view.once_rendered = () => {
			this.accessory_modal_view.init_modal();
			this.accessory_modal_view.init_popup_events();
			this.accessory_modal_view.open();
		};

	}

}